var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"close-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"}},[_c('path',{attrs:{"d":"M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z","fill":"#F2F2F2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }